<!-- Desktop Collapsible Sidebar -->
<aside
  [class]="sidebarService.isCollapsed() ? 'w-[76px] min-w-[76px] max-w-[76px]' : 'w-64 min-w-[260px] max-w-[300px]'"
  class="bg-white border-r border-slate-200 2xl:flex flex-col h-full hidden transition-all duration-300 ease-in-out relative select-none justify-between overflow-hidden"
>
  <div class="p-3 flex flex-col gap-4">
    <!-- Sidebar Header (Logo) -->
    <div class="flex items-center justify-center py-2 h-14 overflow-hidden border-b border-slate-100/80">
      @if (!sidebarService.isCollapsed()) {
        <img
          src="assets/images/asset-logo.png"
          alt="RenewalSmart AI"
          class="max-h-9 max-w-[190px] object-contain transition-opacity duration-200"
        />
      } @else {
        <img
          src="assets/images/renewal-smart-icon.svg"
          alt="RenewalSmart AI"
          class="h-10 w-10 object-contain select-none transition-transform duration-200 hover:scale-105"
        />
      }
    </div>

    <!-- Navigation Items -->
    <nav class="space-y-1.5">
      <a
        routerLink="/dashboard"
        routerLinkActive="bg-primary! text-white! hover:bg-primary! hover:text-white! shadow-xs"
        [pTooltip]="sidebarService.isCollapsed() ? 'Dashboard' : ''"
        tooltipPosition="right"
        [tooltipDisabled]="!sidebarService.isCollapsed()"
        class="flex items-center rounded-xl text-slate-700 hover:bg-primary/10 hover:text-primary transition-all cursor-pointer group"
        [ngClass]="sidebarService.isCollapsed() ? 'justify-center p-3' : 'gap-3 px-3.5 py-2.5'"
      >
        <i class="pi pi-th-large text-base shrink-0"></i>
        @if (!sidebarService.isCollapsed()) {
          <span class="font-medium text-sm whitespace-nowrap overflow-hidden text-ellipsis transition-opacity duration-200">
            Dashboard
          </span>
        }
      </a>

      <a
        routerLink="/import"
        routerLinkActive="bg-primary! text-white! hover:bg-primary! hover:text-white! shadow-xs"
        [pTooltip]="sidebarService.isCollapsed() ? 'Import New Data' : ''"
        tooltipPosition="right"
        [tooltipDisabled]="!sidebarService.isCollapsed()"
        class="flex items-center rounded-xl text-slate-700 hover:bg-primary/10 hover:text-primary transition-all cursor-pointer group"
        [ngClass]="sidebarService.isCollapsed() ? 'justify-center p-3' : 'gap-3 px-3.5 py-2.5'"
      >
        <i class="pi pi-calendar-plus text-base shrink-0"></i>
        @if (!sidebarService.isCollapsed()) {
          <span class="font-medium text-sm whitespace-nowrap overflow-hidden text-ellipsis transition-opacity duration-200">
            Import New Data
          </span>
        }
      </a>
    </nav>
  </div>
</aside>

<!-- Mobile Drawer -->
<p-drawer
  [visible]="drawerOpen || sidebarService.drawerOpen()"
  (visibleChange)="drawerOpenChange.emit($event); sidebarService.setDrawerOpen($event)"
  position="left"
>
  <ng-template #header>
    <div class="flex items-center gap-3 font-bold text-lg leading-tight text-primary">
      <div class="flex justify-center my-2">
        <img src="assets/images/asset-logo.png" alt="Accrete Consulting" class="max-h-8 object-contain" />
      </div>
    </div>
  </ng-template>

  <nav class="space-y-1.5 p-2">
    <a
      routerLink="/dashboard"
      routerLinkActive="bg-primary! text-white! hover:bg-primary! hover:text-white! shadow-xs"
      (click)="drawerOpenChange.emit(false); sidebarService.setDrawerOpen(false)"
      class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-slate-700 hover:bg-primary/10 hover:text-primary transition-all"
    >
      <i class="pi pi-th-large text-base"></i>
      <span class="font-medium text-sm">Dashboard</span>
    </a>
    <a
      routerLink="/import"
      routerLinkActive="bg-primary! text-white! hover:bg-primary! hover:text-white! shadow-xs"
      (click)="drawerOpenChange.emit(false); sidebarService.setDrawerOpen(false)"
      class="flex items-center gap-3 px-4 py-2.5 rounded-xl text-slate-700 hover:bg-primary/10 hover:text-primary transition-all"
    >
      <i class="pi pi-calendar-plus text-base"></i>
      <span class="font-medium text-sm">Import New Data</span>
    </a>
  </nav>
</p-drawer>
